module.exports = __webpack_public_path__ + "img/good_normal.d3e78791.png";